import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { equipments, bindEquipment, unbindEquipment } from '@/api';
import { invoke } from 'wecom-sidebar-jssdk';
import { Tabs, message, Descriptions, Card, Table, Form, Row, Col, Input, Button, Select, Divider, Space, Modal } from 'ant-design-vue';
let ExternalUser = class ExternalUser extends Vue {
    constructor() {
        super(...arguments);
        this.externalUser = {};
        this.activeKey = '1';
        this.equipment_sn = '';
        this.expressQueryData = {
            code: 0,
            data: '',
            message: '',
        };
        this.open = false;
        this.equipmentsData = {};
        this.searchForm = {
            page: 1,
            limit: 1000,
            external_userid: '',
            order_sn: '',
            pay_status: ''
        };
    }
    onClose() {
        this.open = false;
    }
    async bindEquipmentFn() {
        const res = await invoke('getCurExternalContact', {});
        if (!res || !res.userId)
            return;
        console.log('外部联系人 ID', res.userId);
        this.expressQueryData = await bindEquipment({
            sn: this.equipment_sn,
            external_userid: res.userId
        });
        if (this.expressQueryData.code !== 0) {
            message.error(this.expressQueryData.message);
        }
        else {
            this.equipment_sn = '';
            message.success('绑定成功');
        }
        console.log(this.expressQueryData);
    }
    async unbindEquipmentFn(sn) {
        const res = await invoke('getCurExternalContact', {});
        if (!res || !res.userId)
            return;
        console.log('外部联系人 ID', res.userId);
        this.expressQueryData = await unbindEquipment({
            sn: sn,
        });
        if (this.expressQueryData.code !== 0) {
            message.error(this.expressQueryData.message);
        }
        else {
            this.equipment_sn = '';
            message.success('解绑成功');
        }
        console.log(this.expressQueryData);
    }
    async getEquipments() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.searchForm.external_userid = res.userId;
            this.equipmentsData = await equipments(this.searchForm);
        }
        catch (e) {
            message.error(e);
        }
    }
    async mounted() {
        // await this.getExternalUserInfo()
        await this.getEquipments();
    }
};
ExternalUser = __decorate([
    Component({
        name: 'ExternalUser',
        components: {
            'a-modal': Modal,
            'a-divider': Divider,
            'a-space': Space,
            'a-tabs': Tabs,
            'a-card': Card,
            'a-tab-pane': Tabs.TabPane,
            'a-descriptions': Descriptions,
            'a-descriptions-item': Descriptions.Item,
            'a-table': Table,
            'a-form': Form,
            'a-form-item': Form.Item,
            'a-row': Row,
            'a-col': Col,
            'a-input': Input,
            'a-button': Button,
            'a-select': Select,
            'a-select-option': Select.Option,
        }
    })
], ExternalUser);
export default ExternalUser;
